import { render, staticRenderFns } from "./BusdevDashboardNew.vue?vue&type=template&id=1a5e8447"
import script from "./BusdevDashboardNew.vue?vue&type=script&lang=js"
export * from "./BusdevDashboardNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports